import { Injectable, HostListener } from '@angular/core';
import { Observable } from "rxjs";
import { JwtModule, JwtHelperService } from '@auth0/angular-jwt';

import { LoginInfoStorage, UsuarioInfoService } from "./usuario-info.service";
import { UsuarioService } from './usuario.service';
import { Router } from '@angular/router';
import { OrgInfoService } from './org-info.service';
import { OrganizacaoService } from './organizacao.service';

@Injectable()
export class LoginService {

  landingPage: string  = "/app";
  liberaLogin: boolean = false;

  constructor (
    private usuarioInfoService: UsuarioInfoService,
    private usuarioService:     UsuarioService,
    private router:             Router,
    private orgInfo:            OrgInfoService,
    private organizacaoService: OrganizacaoService
  ) {}

  implicitLogin (token: string, rolesAutorizadas: Array<any>, chaveLocal) {    
    
    const helper  = new JwtHelperService();
    let infoToken = helper.decodeToken(token);    

    //VERIFICA SE O USUARIO POSSUI AS ROLES NECESSARIAS
    //SE NAO POSSUIR NAO CONTINUA COM NADA
    let checkRoles = this.verificaRoles(rolesAutorizadas, infoToken);

    if (!checkRoles) {   
      return {'error': 'roles', 'status': false};
    }

    return this.guardarUsuario({infoToken: infoToken, token: token}, chaveLocal);
  }

  guardarUsuario(token, chave) {
    const helper  = new JwtHelperService();

    let loginInfoReturn: LoginInfoStorage;
    loginInfoReturn = {
      "sucesso": true,
      "mensagem": 'Login realizado com sucesso. Redirecionando..',
      "landingPage": this.landingPage,
      "statusHttp": 200,      
      "usuario": {
        idUsuario: token.infoToken.idusu,
        email: "",
        nomeExibicao: "",
        nomeUsuario: token.infoToken.user_name,
        dataExpiracao: helper.getTokenExpirationDate(token.token),
        token: token,
        cargo: "",        
        funcoes: token.infoToken.authorities,
        idOrg:   token.infoToken.idorg,
        idDom:   token.infoToken.iddom,
        idCgm:   token.infoToken.idcgm,
        idPes:   token.infoToken.idpes != null && typeof token.infoToken.idpes != 'undefined' ? token.infoToken.idpes : null,
        chaveSistema: chave,
        idCgo: token.infoToken.idcgo != null && typeof token.infoToken.idcgo != 'undefined' ? token.infoToken.idcgo : null,
        idSec: token.infoToken.idsec != null && typeof token.infoToken.idsec != 'undefined' ? token.infoToken.idsec : null,
        idDep: token.infoToken.iddep != null && typeof token.infoToken.iddep != 'undefined' ? token.infoToken.iddep : null,
        idSet: token.infoToken.idset != null && typeof token.infoToken.idset != 'undefined' ? token.infoToken.idset : null
      }
    };
    this.usuarioInfoService.guardaInfoUsuario(JSON.stringify(loginInfoReturn.usuario));     
    return true;
  }

  /**
   * GERA A CHAVE QUE FAZ A VERIFICACAO DE MUDANÇA
   * DO USUARIO DE ACORDO COM O SISTEMA LOGADO
   */
  geraChave () {
    return ((+ new Date() + Math.random() * 100).toString(32));
  }

  verificaRoles (rolesAutorizadas: Array<any>, infoToken: any) : boolean {
    if (rolesAutorizadas == null || typeof rolesAutorizadas == 'undefined' || rolesAutorizadas.length == 0) {
      return true;
    }
    for (let roleAutorizada of rolesAutorizadas) {
      let index = infoToken.authorities.indexOf(roleAutorizada);
      if (index >= 0) {
        return true;
      }
    }    
    return false;
  }

  finalizarLogin (dominioAdm: string, urlServerCad: string, urlServerUser: string) {  

    if (parseInt(this.usuarioInfoService.getIdDom()) === parseInt(dominioAdm)) {
      this.router.navigate(['/selecao-organizacao']);
      return false;
    }

    this.organizacaoService.getDadosOrganizacao (urlServerCad + "/organizacao/" + this.usuarioInfoService.getIdOrg(), true)
      .subscribe (res => {
        this.setStorageOrg(JSON.stringify(res));
        this.getUserData(urlServerUser);
      }, error => {
        alert("Ocorreu um erro ao recuperar a organização, por segurança você será desconectado.");
        ///lothis.toastr.error("Ocorreu um erro ao recuperar a organização, por segurança você será desconectado.");
        this.router.navigate(['/sair']);
      });
  }
  
  getUserData (urlServerUser: string) {
    this.usuarioService.getDadosUsuario (urlServerUser + "/usuario/tokendetail")
    .subscribe (r => {
      this.usuarioInfoService.setEmail(r.usuario.email);
      this.usuarioInfoService.setNome(r.usuario.nome);
      this.router.navigate(['app/dashboard']);
    }, error => {
      this.router.navigate(['app/dashboard']);
    })
  }

  setStorageOrg (data: any) {
    /*CASO EXISTA ALGUMA ORGANIZACAO SELECIONADA
    *EXCLUI ANTES DE ADICIONAR UMA NOVA*/   
    if (this.orgInfo.getOrganizacao()) {
      this.orgInfo.removerOrganizacao();
    }    
    this.orgInfo.adicionarOrganizacao(data);        
  }

}
